import React from "react";

import { Form, SubmitButton, ResetButton } from "formik-antd";
import { Formik } from "formik";

import { Space, Divider, PageHeader, Col, Row, Button } from "antd";

import { CloudUploadOutlined } from "@ant-design/icons";

export const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

function validateRequired(value) {
    return value ? undefined : "required";
}

const BasicForm = (props) => (
    <PageHeader
        ghost={false}
        onBack={props.onPressBack}
        title={props.titulo}
        subTitle={props.subtitulo ? props.subtitulo : "FORM"}
        extra={props.extra || false}
    >
        <Formik initialValues={props.initialValues} validationSchema={props.validationSchema} onSubmit={props.onSubmit} enableReinitialize>
            {({ values, submitForm, setFieldValue, errors, touched, setFieldTouched, isValid, isSubmitting }) => (
                <Form labelCol={{ xs: 4 }} wrapperCol={{ xs: 16 }}>
                    {props.render({
                        values,
                        submitForm,
                        setFieldValue,
                        errors,
                        touched,
                        setFieldTouched,
                        isValid,
                        isSubmitting,
                        validateRequired,
                        _filter,
                    })}

                    <Row>
                        <Col span={16} offset={4}>
                            {props.onPressBack && (
                                <button onClick={props.onPressBack} type="button" className="ant-btn ant-btn-default">
                                    <i className="fa fa-arrow-left"></i>
                                    <Divider type="vertical" />
                                    Cancel
                                </button>
                            )}
                            <div className="pull-right">
                                <Space>
                                    {props.onSecondaryButton && (
                                        <Button
                                            type="default"
                                            onClick={() => props.onSecondaryButton(values)}
                                            disabled={isSubmitting}
                                        >
                                            {props.secondaryButtonLabel}
                                        </Button>
                                    )}
                                    <Button
                                        type="primary"
                                        onClick={() => submitForm()}
                                        disabled={isSubmitting}
                                        icon={<CloudUploadOutlined />}
                                        loading={isSubmitting}
                                    >
                                        <Divider type="vertical" />
                                        {isSubmitting ? "One moment ..." : "Save"}
                                    </Button>
                                </Space>
                            </div>
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    </PageHeader>
);

export default BasicForm;
